import { useState, useEffect } from 'react';

/**
 * Captura o evento beforeinstallprompt do browser.
 * Retorna:
 *   - canInstall: true quando o app pode ser instalado
 *   - install(): abre o prompt nativo de instalação
 */
export function usePWAInstall() {
  const [prompt, setPrompt] = useState(null);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setPrompt(e);
    };

    window.addEventListener('beforeinstallprompt', handler);

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const install = async () => {
    if (!prompt) return;
    prompt.prompt();
    const { outcome } = await prompt.userChoice;
    if (outcome === 'accepted') setPrompt(null);
  };

  return { canInstall: Boolean(prompt), install };
}